var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import AreaSelect from '@/components/AreaSelect/AreaSelect.vue';
import AreaFilter from '@/components/SummaryFilters/AreaFilter/AreaFilter';
import LabelValue from '@/components/LabelValue.vue';
import ErrorHandler from '@/support/ErrorHandler';
import { LabelGroup } from '@/models/LabelGroup';
import { LabelKey } from '@/models/Label';
let AddStatusSetDialog = class AddStatusSetDialog extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.set = null;
        this.currentStep = 1;
        this.isLoading = true;
        this.labels = [
            {
                key: LabelKey.BUSY,
                value: '',
            },
            {
                key: LabelKey.HIGHLIGHTED,
                value: '',
            },
            {
                key: LabelKey.LESSON_DONE,
                value: '',
            },
            {
                key: LabelKey.OLD,
                value: '',
            },
            {
                key: LabelKey.FINISHED,
                value: '',
            },
            {
                key: LabelKey.CLOSED,
                value: '',
            },
            {
                key: LabelKey.INACTIVE,
                value: '',
            },
            {
                key: LabelKey.FUTURE,
                value: '',
            },
        ];
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.initializeSet();
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    close() {
        this.$emit('input', false);
        this.clear();
    }
    clear() {
        this.currentStep = 1;
        this.set = null;
        this.labels = [
            {
                key: LabelKey.LESSON_DONE,
                value: '',
            },
            {
                key: LabelKey.HIGHLIGHTED,
                value: '',
            },
            {
                key: LabelKey.BUSY,
                value: '',
            },
            {
                key: LabelKey.CLOSED,
                value: '',
            },
            {
                key: LabelKey.OLD,
                value: '',
            },
            {
                key: LabelKey.INACTIVE,
                value: '',
            },
            {
                key: LabelKey.FINISHED,
                value: '',
            },
            {
                key: LabelKey.FUTURE,
                value: '',
            },
        ];
    }
    onSubmit() {
        if (!this.set) {
            return;
        }
        const labelsPayload = {};
        this.labels.forEach((label) => {
            if (label.key && label.value) {
                labelsPayload[label.key] = label.value;
            }
        });
        const payload = {
            name: this.set.name,
            labels: labelsPayload,
        };
        if (this.isEditing) {
            this.onUpdateSet(payload);
        }
        else {
            this.onCreateSet(payload);
        }
    }
    getDotColor(key) {
        switch (key) {
            case LabelKey.HIGHLIGHTED:
                return '#ffc100';
            case LabelKey.BUSY:
                return '#008ac4';
            case LabelKey.CLOSED:
                return '#d0021b';
            case LabelKey.OLD:
                return '#ff7800';
            case LabelKey.INACTIVE:
                return '#9b9b9b';
            case LabelKey.FINISHED:
                return '#00b900';
            case LabelKey.FUTURE:
                return '#000000';
            case LabelKey.LESSON_DONE:
                return '#800080';
            default:
                return '#9b9b9b';
        }
    }
    // #endregion
    // #region Async methods (api calls only)
    async onUpdateSet(payload) {
        try {
            await this.existingSet.update(payload);
            this.$emit('setUpdated');
            this.clear();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async onCreateSet(payload) {
        try {
            await new LabelGroup().create(payload);
            this.$emit('setCreated');
            this.clear();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async initializeSet() {
        if (this.existingSet && this.existingSet.labels) {
            this.set = this.existingSet;
            this.labels = this.existingSet.labels.map((label) => {
                return {
                    key: label.key,
                    value: label.value,
                };
            });
        }
        else {
            this.set = new LabelGroup();
        }
    }
    // #endregion
    // #region Getters & Setters
    get disabled() {
        switch (this.currentStep) {
            case 1:
                return !this.set || !this.set.name;
            case 2:
                return !this.labels.every((label) => {
                    return label.value && label.key;
                });
            case 3:
                return false;
            default:
                return true;
        }
    }
    get submitButtonText() {
        return this.$tc('Save');
    }
    get isEditing() {
        return !!this.existingSet;
    }
    get title() {
        return this.isEditing ? this.$tc('Edit status set') : this.$tc('Create status set');
    }
    get selectedLabelValuesText() {
        return this.labels.map((label) => {
            return label.value;
        }).join(', ');
    }
    // #endregion
    // #region @Watchers
    async onExistingSetChange() {
        this.isLoading = true;
        await this.initializeSet();
        this.isLoading = false;
    }
};
__decorate([
    Prop({ required: false }),
    __metadata("design:type", typeof (_a = typeof LabelGroup !== "undefined" && LabelGroup) === "function" ? _a : Object)
], AddStatusSetDialog.prototype, "existingSet", void 0);
__decorate([
    Watch('existingSet'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
], AddStatusSetDialog.prototype, "onExistingSetChange", null);
AddStatusSetDialog = __decorate([
    Component({
        components: {
            DataTable,
            AreaSelect,
            AreaFilter,
            LabelValue,
        },
    })
], AddStatusSetDialog);
export default AddStatusSetDialog;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
